// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__fe_x6","title":"InfoRow_title__37att"};